//
//
//
//
//
//
//
//
//
//
//
//

import cmHeader from '@/components/cmHeader.vue'

export default {
  name: 'app',
  components: {
      cmHeader
  },
  provide () {
    return {
      // reload: this.reload
    }
  },
  data () {
    return {
      // isRouterAlive: true
    }
  },
  methods: {
    // reload () {
    //   this.isRouterAlive = false
    //   this.$nextTick(function () {
    //     this.isRouterAlive = true
    //   })
    // }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue